import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { Form, Input, Icon, Modal, Select,message,Tooltip } from 'antd';
import { layout, Button } from 'icsoc-antd-ex';
import { SmallPopover } from 'icsoc-antd-ex';
import CommonTable from 'Components/common/commonTable';
import tUserManagement from 'Actions/systemSetting/userManagement';
import './index.less';
const { BaseContentMainHeader } = layout;
const FormItem = Form.Item;
const { Option } = Select;
import moment from 'moment';

let columns = [];
class userManagement extends React.PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            loading: false, // 列表loading 
            tableListData: [],
            pageStatus: { pageNum: 1, pageSize: 10 ,search:''},
            total: 0,
            visible: false,
            addUsername:'',
            selectList:[],
            userId:'',
            roleId:''
        }
    }
    componentDidMount() {
        this.initData();
        this.setOperate();
    }
    initData(){
        const {actions} = this.props;
        let params=this.state.pageStatus;
        this.setState({loading:true})
        actions.getUserList(params).then(res=>{
            this.setState({tableListData:res.payload.data.list,total:res.payload.data.total})
        }).finally(() => {
            this.setState({loading:false})
          });
    }
    setOperate = () => {
        columns=[
            {
                title: '姓名',
                key: 'userName',
                dataIndex: 'userName',
                //fixed:'left',
                ellipsis: true,
                width: 120,
                render: (text, record, index) =>  text || '--'               
            },
            {
                title: '昵称',
                dataIndex: 'agNickName',
                key: 'agNickName',
                width: 100,
                ellipsis: true,
                render: text => text || '--' 
            },
            {
                title: '工号',
                dataIndex: 'userNum',
                key: 'userNum',
                ellipsis: true,
                width: 80,
                render: text => text || '--' 
            },
            {
                title: '手机',
                dataIndex: 'userSmsPhone',
                key: 'userSmsPhone',
                ellipsis: true,
                width: 120,
                render: text => text || '--' 
            },
            {
                title: '邮箱',
                dataIndex: 'userEmail',
                key: 'userEmail',
                ellipsis: true,
                width: 120,
                render: text => text || '--' 
            },
            {
                title: '部门',
                dataIndex: 'deptName',
                key: 'deptName',
                ellipsis: true,
                width: 120,
                render: text => text || '--' 
            },
            {
                title: '角色',
                dataIndex: 'roleName',
                key: 'roleName',
                ellipsis: true,
                width: 120,
                render: text => text || '--' 
            },
            {
                title: '创建时间',
                dataIndex: 'createTime',
                key: 'createTime',
                width: 150,
                render: text => (text && moment(text).format('YYYY-MM-DD HH:mm:ss')) || '--'
            },
            // {
            //     title: '最后登录时间',
            //     key: 'updateTime',
            //     dataIndex: 'updateTime',
            //     width: 100,
            //     ellipsis: true,
            //     render: text =>
            //     ((text && moment(text).format('YYYY-MM-DD HH:mm:ss')) || '--')
            // },
        ]
        columns.push(
            {
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                width: 80,
                align:'center',
                fixed: 'right',
                render: (text, record) => {
                    const showConfigModal = () => {
                        this.setState({ visible: true,addUsername:'' })
                        this.props.actions.getSelect(record.userId).then(res=>{
                            this.setState({selectList:res.payload.data.list,userId:record.userId})
                            if(res.payload.data.checkedList.length>0){
                                let idx=res.payload.data.list.findIndex(el=>el.id==res.payload.data.checkedList[0])
                                this.setState({roleId:res.payload.data.checkedList[0],addUsername:res.payload.data.list[idx].name})
                            }
                        })
                    }
                    return (
                        <div>
                            {
                                this.props.login.permissionsList.includes('systemSettingUserManagement.addRole') ?
                                <SmallPopover type="white" content="添加角色" className="tooltip">
                                    <Icon type="user-add" onClick={() => showConfigModal(record)} style={{ fontSize: '16px' }} />
                                </SmallPopover>
                            : null} 
                        </div>
                    )
                }
            }
        )
    }
    searchList = () => {
        const { getFieldsValue, getFieldValue } = this.props.form;
        let search = getFieldValue('search').trim();
        this.setState({
            pageStatus:{search:search,pageNum:1,pageSize:this.state.pageStatus.pageSize}
        },()=>{this.initData()}) 
    }
    handleOk = () => {
        const {actions} =this.props;
        let userId=this.state.userId;
        let id=this.state.roleId;
        actions.addRoles(userId,id).then(res=>{
            message.success('操作成功！');
            this.setState({visible:false});
            this.initData();
        })
    }
    handleCancel = () => {
        this.setState({ visible: false })
    }
    handleTableChange = (pagination) => {
        this.setState({
            pageStatus:{
                pageNum:pagination.current,
                pageSize:pagination.pageSize
            }
        },()=>{
            this.initData();
        })
       
    }
    handleChange = (value,option) => {
        if(value){
            this.setState({addUsername:value,roleId:option.props.value });
        }else{
            this.setState({addUsername:'',roleId:'' }); 
        }
    };
    render() {
        const { getFieldDecorator } = this.props.form;
        const {
            tableListData,
            loading,
            pageStatus,
            total,
            selectList
        } = this.state;
        return (
            <div className='userManagement-wrap'>
                <BaseContentMainHeader title="用户管理"></BaseContentMainHeader>
                <Form layout="inline" style={{ marginTop: '10px' }}>
                    <FormItem label='用户名'>
                        {getFieldDecorator('search', {
                            initialValue: ''
                        })(<Input placeholder='姓名/昵称/工号/邮箱/手机号搜索' size='large ' style={{ width: '280px' }} />)}
                    </FormItem>
                    <FormItem>
                        <Button type="primary" onClick={this.searchList}>
                            <span>查询</span>
                        </Button>
                    </FormItem>
                </Form>
                <CommonTable
                    style={{ marginTop: 20 }}
                    columns={columns}
                    dataSource={tableListData}
                    rowKey="id"
                    loading={loading}
                    extraHeight={20}
                    scroll={{ x: 1300 }}
                    onChange={this.handleTableChange}
                    pagination={{
                        current: pageStatus.pageNum,
                        total: total && parseInt(total, 10),
                        pageSize: pageStatus.pageSize,
                        showTotal: () => `共 ${total} 条`,
                    }}
                />
                <Modal
                    title="用户添加角色"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                >
                    <Form layout="inline">
                        <FormItem label='角色名称'>
                            <Select
                                showSearch
                                allowClear
                                value={this.state.addUsername}
                                placeholder='请输入角色名称'
                                style={{width:'300px'}}
                                defaultActiveFirstOption={false}
                                showArrow={false}
                                onChange={this.handleChange}
                                notFoundContent={null}
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                { selectList ? selectList.map(item => (
                                    <Select.Option key={item.id} value={item.id}>
                                        {item.name}
                                    </Select.Option>
                                )): null}
                            </Select>
                        </FormItem>
                    </Form>
                </Modal>
            </div>
        )
    }
}
const mapStateToProps = state => ({
    login:state.login
});
  
const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(tUserManagement, dispatch),
});
export default 
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )
  (Form.create()(userManagement));